import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from '../shared/app.service';
import { StandpuntStatus, IDetailZitting } from '../detail-zitting/detail-zitting.service';
import { state2 } from '../shared/state';
import { IAgendapuntDb, ISubpuntDb, IReferencedPuntDb, IDocumentDb, INotitieDb, IDetailAgendapuntDb } from '../shared/offline/cobradb';
import { of, Observable } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';

export interface ISubPunt {
  Titel: string;
}
export interface IReferencedPunt {
  Titel: string;
  Id: number;
}
export interface IDocument {
  Id: number;
  Titel: string;
}
export interface INotitie {
  Id: number;
  NotitieId: number;
  AgendapuntId: number;
  PersoonNaam: string;
  PersoonId: number;
  DatumInsert: Date | string;
  DatumUpdate: Date | string;
  Inhoud: string;
  AantalPersonen: number;
  Persoonlijk: boolean;
}
export interface IDetailPunt {
  Punt?: IAgendapuntDb;
  Subpunten: ISubpuntDb[];
  GekoppeldePunten: IReferencedPuntDb[];
  Documenten: IDocumentDb[];
  Notities: INotitieDb[];
}

export interface IAgendapuntResult {
  agendapunt: IAgendapuntDb;
  detail: IDetailAgendapuntDb;
}

export interface IAgendapuntViewResult {
  agendapunt: IAgendapuntResult;
  agendapuntIds: number[];
  bespreken: boolean;
}

export interface IBoaActivity {
  Id: string;
  Description: string;
  Subject: string;
  Customer: IBoaCustomer;
  Attachments: IBoaAttachment[]
}

export interface IBoaAttachment {
  Subject: string;
  Name: string;
  DocRef: string;
  Extensie: string;
}

export interface IBoaCustomer {
  LastName: string;
  FirstName: string;
}

@Injectable()
export class AgendapuntService {

  constructor(private http: HttpClient, private appService: AppService) { }

  getDetailAgendapunt(zittingId: number, puntId: number): Observable<IAgendapuntResult> {
    const agendapuntUrl = this.appService.getUrl(`api/Agendapunt/getagendapunt?puntid=${puntId}`);
    const detailAgendapuntUrl = this.appService.getUrl(`api/Agendapunt/getdetailagendapuntex?puntid=${puntId}`);
    const agendapuntenWithExt$ = this.http.post<IDetailAgendapuntDb>(detailAgendapuntUrl, {}).pipe(
      map(a => { a.Documenten.forEach(d => d.Titel = this.appService.getTitelWithExtension(d.Titel, d.Verwijzing)); return a; })
    );

    return state2.getSubValueOrDefault<IDetailZitting>('detailzittingdata', zittingId, of(undefined)).pipe(
      map(zittingData => zittingData || { agendapunten: [] }),
      map(zittingdata => zittingdata.agendapunten.find(a => a.Id === puntId)),
      mergeMap(punt => punt === undefined ? this.http.post<IAgendapuntDb>(agendapuntUrl, {}) : of(punt)),
      mergeMap(agendapunt =>
        state2.getSubValueOrDefault('detailagendapuntdata', puntId, agendapuntenWithExt$).pipe(
          map(detail => ({ agendapunt, detail }))
        )
      )
    );
  }

  getAgendapuntIds(zittingId: number, bespreken = false) {
    const besprekenArg = bespreken ? '&bespreken=true' : '';
    const url = this.appService.getUrl(`api/Zitting/getAgendapuntIds?zittingId=${zittingId}${besprekenArg}`);
    // subkey negatief maken zodat indien bespreken gewijzigd is juiste gecachete agendapuntIds gevonden wordt.
    const newZittingId = bespreken ? -zittingId : zittingId;
    return state2.getSubValueOrDefault('agendapuntids', newZittingId, this.http.post<number[]>(url, {}));
  }

  toggleBookmark(puntId: number, bladwijzerId: number) {
    //TODO misschien beter in bookmarkservice (ifv state.remove 1x)
    const url = this.appService.getUrl(`api/Agendapunt/togglebookmark?puntId=${puntId}&bladwijzerId=${bladwijzerId ?? ''}`);
    return this.http.post<number | null>(url, {}).pipe(tap(_ => state2.remove('recentebladwijzers')));
  }
  verwijderNotitie(notitieId: number) {
    const url = this.appService.getUrl(`api/Notitie/VerwijderNotitie/${notitieId}`);
    return this.http.post<boolean>(url, {});
  }

  getBoaDetail = (id: string) =>
    this.http.post<IBoaActivity>(this.appService.getUrl(`api/Boa/GetDetail/${id}`), null)

}
